import * as React from "react";
import * as companyData from "../../constants/company-data";
import * as staticUrls from "../../constants/static-urls";
import styled from "styled-components";

interface TopBarProps {}

const TopBar = (props: TopBarProps) => {
  return (
    <div className="materialize-theme-styles">
      <TopBarWrapper className="top-bar light-blue">
        <div className="row">

          <div className="col-md-6">
            <ul className="list-inline social-top tt-animate btt">
              <li><a href={staticUrls.FAKTUROMANIA_FACEBOOK_PAGE_URL} target="_blank" rel="nofollow"><i className="fa fa-facebook"></i></a></li>
              <li><a href={staticUrls.FAKTUROMANIA_TWITTER_PAGE_URL} target="_blank" rel="nofollow"><i className="fa fa-twitter"></i></a></li>
              <li><a href={staticUrls.FAKTUROMANIA_LINKED_IN_PAGE_URL} target="_blank" rel="nofollow"><i className="fa fa-linkedin"></i></a></li>
            </ul>
          </div>

          <TopBarContactInfoWrapper className="col-md-6 text-right">
            <ul className="topbar-cta no-margin">
              <li className="mr-20">
                <a><i className="material-icons mr-10">&#xE0B9;</i>info@fakturomania.pl</a>
              </li>
              <li>
                <a><i className="material-icons mr-10">&#xE0CD;</i> +48 {companyData.FAKTUROMANIA_APP_COMPANY_PHONE}</a>
              </li>
            </ul>
          </TopBarContactInfoWrapper>

        </div>
      </TopBarWrapper>
    </div>
  )
};

/** STYLES */

const TopBarWrapper = styled.div`
  div.row {
    display: flex !important;
    justify-content: space-between !important;
    width: 100%;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const TopBarContactInfoWrapper = styled.div`
  width: 100%;
`;

export default TopBar


// WEBPACK FOOTER //
// ./src/layouts/top-bar/top-bar.tsx